import { FC } from 'react';

import { Tab } from '@elements/tab';
import { useBoostDetailsStore } from '@store';

import { BoostCoverItems, BoostCoverItemsProps } from '../boostCoverItems';

interface BoostCoveredAndNotCoveredTabProps extends React.HTMLAttributes<HTMLDivElement> {
  boostId?: string;
  boostCoverItemsProps?: BoostCoverItemsProps;
  header?: React.ReactNode;
  onChange?: () => void;
}
export const BoostCoveredAndNotCoveredTab: FC<BoostCoveredAndNotCoveredTabProps> = ({
  boostCoverItemsProps,
  className,
  header,
  boostId,
  ...rest
}) => {
  const boostDetails = useBoostDetailsStore(state => {
    const mandatoryBoostId = state?.mandatoryBoostDetails?.boostId;
    return mandatoryBoostId === boostId ? state.mandatoryBoostDetails : state.boostDetails;
  });
  const coveredItems = boostDetails?.template.coverDetails.covered.items ?? [];
  const notCoveredItems = boostDetails?.template.coverDetails.notCovered.items ?? [];
  const pdsLink = boostDetails?.template.pdsLink?.value;

  return (
    <Tab
      {...rest}
      tabs={[
        {
          tabName: "What's covered",
          panel: (
            <div>
              {header}
              <BoostCoverItems
                className={className}
                boostCoverItems={coveredItems}
                isCovered
                isMandatory={boostDetails?.isMandatory}
                pdsLink={pdsLink}
                {...boostCoverItemsProps}
              />
            </div>
          ),
        },
        {
          tabName: "What's not covered",
          panel: (
            <div>
              <BoostCoverItems
                className={className}
                boostCoverItems={notCoveredItems}
                isMandatory={boostDetails?.isMandatory}
                isCovered={false}
                pdsLink={pdsLink}
                {...boostCoverItemsProps}
              />
            </div>
          ),
        },
      ]}
    />
  );
};
